import WorkspaceSecondaryButton from "@/components/SecondaryButton";
import { withClassroomContext } from "@/components/workspace/navigation";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "@/components/PrimaryButton";
import { Size } from "@ever-tutor/et-ui";

type TeacherProps = {
  variant: "teacher";
  onCreateSpace: () => void;
};

type StudentProps = {
  variant: "student";
  classroomId?: string;
  lastActiveRoom?: { spaceId: string; spaceName: string } | null;
};

type SpaceWelcomeProps = TeacherProps | StudentProps;

export default function SpaceWelcome(props: SpaceWelcomeProps) {
  const navigate = useNavigate();

  return (
    <div className="et-welcome et-space-welcome">
      {props.variant === "teacher" ? (
        <div className="flex flex-col-reverse md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col gap-4 text-[#294b39]">
            <h1 className="text-2xl md:text-4xl">
              Start a{" "}
              <span className="font-libre-baskerville italic">Space</span>
            </h1>
            <p className="text-base md:text-lg font-normal max-w-md">
              Bring your class together. You lead — AI is your teaching
              assistant.
            </p>
            <div>
              <PrimaryButton size={Size.MD} onClick={props.onCreateSpace}>
                + New Space
              </PrimaryButton>
            </div>
          </div>
          <img
            src="/design/spaces.webp"
            alt=""
            className="hidden md:block h-40 object-contain"
          />
        </div>
      ) : (
        <div className="flex flex-col-reverse sm:flex-row justify-between items-center gap-6">
          <div className="flex flex-col gap-4 text-[#294b39]">
            <h1 className="text-2xl md:text-4xl">
              Join a{" "}
              <span className="font-libre-baskerville italic">Space</span>
            </h1>
            <p className="text-base md:text-lg font-normal max-w-md">
              Connect with your class and learn together — with a little help
              from AI.
            </p>
            {props.lastActiveRoom && (
              <WorkspaceSecondaryButton
                onClick={() =>
                  navigate(
                    withClassroomContext(
                      `/spaces/${props.lastActiveRoom!.spaceId}`,
                      props.classroomId,
                    ),
                  )
                }
                className="et-secondary-button"
              >
                ↩ Rejoin: {props.lastActiveRoom.spaceName}
              </WorkspaceSecondaryButton>
            )}
          </div>
          <img
            src="/design/classroom-conversation.webp"
            alt=""
            className="hidden sm:block h-40 object-contain"
          />
        </div>
      )}
    </div>
  );
}
